<template>
	<view class="u-content">
	    <u-parse :content="content"></u-parse>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				content: ''
			};
		},
		onLoad(options) {
			
		}
	}
</script>

<style lang="scss" scoped>
	.u-content {
		padding: 30rpx;
	}
</style>
